import React, { Fragment, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { slide as Menu } from 'react-burger-menu'
import logoimg from '../../assets/images/logo.png';
import '../../styles/header.scss';

function Header() {

        return (
        <Fragment>
            <header className='header'>
                <Row xs={2} lg={3}>
                    <Col xs={12} lg={3}>
                        <a href="/especificacoes" alt="Prefeitura Municipal de Macuco - Departamento de TI">
                            <img src={logoimg} className='logo' alt="Prefeitura Municipal de Macuco - Departamento de TI" />
                        </a>
                    </Col>
                    <Col xs={12} lg={6}>
                        <a href="/especificacoes" alt="Sistema de Solicitação de Especificações Técnicas">
                            <h4 className='tit'>Sistema de Solicitação de Especificações Técnicas</h4>
                        </a>
                    </Col>
                </Row>
                <Menu right>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br">Site da Prefeitura</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia">Portal da Transparência</a>
                    <a className="menu-item" href="https://webmail.prefeituramacuco.rj.gov.br">Webmail</a>
                    <a className="menu-item" href="https://macuco.govbr.cloud/ps#/">Contra-cheque Online</a>
                </Menu>
            </header>
        </Fragment >

    )
}

export default Header;